import React from 'react';
import { Redirect } from 'react-router-dom';

export default class LoginAuth extends React.PureComponent {
    render() {
        window.localStorage.setItem('authToken', this.props.match.params.token);
        return <Redirect to="/#/login" />;
    }
}